import React from "react";

import { Col, Container, Row } from "react-bootstrap";
import DsnGrid from "../components/DsnGrid";

import HeaderNormalTow from "../components/header/HeaderNormalTow";
import Footer from "../components/footer/Footer";
import InfoBox from "../components/contact/InfoBox";
import ContactForm from "../components/contact/ContactForm";
import { Helmet } from "react-helmet";
import ParallaxImage from "../components/parallax-image/ParallaxImage";

const headerContent = {
  title: "Whisper",
  description: `Let's connect`,
};

function Contact() {
  return (
    <React.Fragment>
      <Helmet>
        <title>Contact | Mystirien</title>
        <meta property="og:title" content="Contact | Mystirien" />
        <meta
          property="og:description"
          content="Get in touch with Mystirien, the Celtic-fantasy artist creating immersive music and art experiences."
        />
        <meta property="og:url" content="https://mystirien.com/contact" />
        <meta
          property="og:image"
          content="https://mystirien.com/assets/img/mystirien-og.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {/*Start Header*/}
      <HeaderNormalTow description={headerContent.description}>
        {headerContent.title}
      </HeaderNormalTow>

      {/*Start Map*/}
      <Container>
        <Row>
          <Col xl={5} className="item-box">
            <div className="inner-img p-relative">
              <ParallaxImage
                src="/assets/img/contact-map.jpg"
                height="100%"
                width="100%"
                style={{ background: "red" }}
              />
            </div>
          </Col>
        </Row>
      </Container>

      {/*Start Contact Form && Info Box*/}
      <Container className="section-margin">
        <DsnGrid col={2} colTablet={1}>
          <InfoBox className="background-section p-30" />
          <ContactForm />
        </DsnGrid>
      </Container>

      <Footer />
    </React.Fragment>
  );
}

export default Contact;
